import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const propTypes = {
	isDisabled: PropTypes.bool,
	fetching: PropTypes.bool,
	modality: PropTypes.string.isRequired,
	goals: PropTypes.array.isRequired,
	canAdd: PropTypes.func.isRequired,
	goalAdd: PropTypes.func.isRequired
}

const defaultProps = {
	isDisabled: true,
	fetching: false
}

class GoalSelectorWidget extends Component {
	render() {
		const {isDisabled, goals, fetching} = this.props;
		!_.isEmpty(goals) && _.sortBy(goals, ['name']);
		return <div className="columns">
			<div className="column">
				<h5 className="title is-5">Selección de metas</h5>
				<div className="field has-addons">
					<div className="control is-expanded">
						<div className="select is-fullwidth project-goal-select">
							<select id="goal" ref="goalsSelect" onChange={() => this.updateAddGoalState()} disabled={isDisabled}>
								<option value="0" defaultValue>--- Selecciona una meta ---</option>
								{!_.isEmpty(goals) && _.map(goals, (option, key) => {
									return <option key={key} value={option.id}>{option.name}</option>
								})}
							</select>
						</div>
					</div>
					<div className={`control${fetching}`}>
						<button type="button" className="button is-info" onClick={() => this.addGoalToList()} disabled={isDisabled}>
							Agregar Meta
						</button>
					</div>
				</div>
			</div>
		</div>
	}

	updateAddGoalState() {
		this.props.canAdd(this.refs.goalsSelect.value);
	}

	addGoalToList() {
		this.props.goalAdd(this.refs.goalsSelect.value);
		return this.refs.goalsSelect.value = 0;
	}
}

GoalSelectorWidget.propTypes = propTypes;
GoalSelectorWidget.defaultProps = defaultProps;

export default GoalSelectorWidget;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/goal_selector.jsx